var convert = require('./convert'),
    func = convert('compact', require('../compact'), require('./_falseOptions'));

func.placeholder = require('./placeholder');
module.exports = func;



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/lodash/fp/compact.js
 ** module id = 1671
 ** module chunks = 0
 **/